import { Modal } from 'antd';
import React from 'react';


const FeedbackModal = ({ isOpen, onClose, feedback, score }) => {
  return (
    <Modal open={isOpen} onCancel={onClose} onOk={onClose}>
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-4">Interview Feedback</h2>
        <div className="mb-4">
          <span className="text-lg font-semibold">Score: </span>
          <span className={`px-3 py-1 rounded ${
            score >= 70 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            {score}%
          </span>
        </div>
        <div className="prose max-w-none">
          <h3 className="text-lg font-semibold mb-2">Detailed Feedback:</h3>
          <p className="text-gray-700 whitespace-pre-wrap">{feedback}</p>
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackModal; 